import React from 'react';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
export const I18nLibraryProvider = ({ locale, children, }) => {
    const i18n = initI18n({
        locale: locale || 'en',
        useSuspense: true,
        asyncMessagesLoader: (lang) => import(`../assets/locale/dev-center-pages-common/messages_${lang}.json`),
    });
    return React.createElement(I18nextProvider, { i18n: i18n }, children);
};
//# sourceMappingURL=I18nLibraryProvider.js.map